import { AuthError } from '@auth0/nextjs-auth0'
import { ERROR_CODES, ErrorCodes, GenericException } from '@reward-platform/shared-api/exceptions'

export class Auth0B2CException extends GenericException {
  constructor(error?: AuthError | Error, errorCode: `${ErrorCodes}` = 'REQUEST_INVALID') {
    super({
      ...ERROR_CODES[errorCode],
      description: 'Auth0 B2C Error',
      originalError: error,
    })

    if (error?.message) {
      this.developerMessage = error?.message
    }

    if (error instanceof AuthError && error.code) {
      this.system = 'internal-iagl-auth0-b2c'
    }
  }
}
